const padTokens = (x: number | string): string => x.toString().padStart(2, '0')
export const formatTime = (date: Date, now = Date.now()): string => {
  const ms = ((now - date.getTime()) / 1000) * -1
  const seconds = Math.floor(ms) % 60

  const minutes = Math.floor(ms / 60) % 60
  const hours = Math.floor(ms / 60 / 60)

  if (hours)
    return `${padTokens(hours)}h${padTokens(minutes)}m${padTokens(seconds)}s`
  if (minutes) return `${padTokens(minutes)}m${padTokens(seconds)}s`
  return `${seconds}s`
}
